import { styled } from '@mui/system';
import { Button, Select, MenuItem, Typography } from '@mui/material';

const Container = styled('div')(({ theme }) => ({
  bottom: '0',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '24px',
}));

const AddContainer = styled('div')({
  width: '100%',
  height: '100%',
  justifyContent: 'start',
  alignItems: 'center',
});

const AddButton = styled(Button)({
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Poppins',
  height: 42,
  width: '100%',
});

const UnitsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

const HeaderModal = styled('div')({
  padding: '10px 5px 10px 20px',
  textAlign: 'start',
  fontWeight: 500,
  display: 'flex',
  fontFamily: 'Poppins',
  justifyContent: 'space-between',
  fontSize: '14px',
  lineHeight: '19px',
});

const SelectContainer = styled(Select)({
  width: '100%',
  height: 42,
  fontSize: 13,
  fontWeight: 400,
  fontFamily: 'Poppins',
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#EAEAEA',
  },
  cursor: 'pointer',
});

const MenuItemText = styled(MenuItem)({
  fontSize: 13,
  fontWeight: 400,
  fontFamily: 'Poppins',
  color: '#747474',
  justifyContent: 'center',
  alignItems: 'center',
});

const HelperText = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  fontFamily: 'Poppins',
  color: '#414046',
  lineHeight: '15px',
});

const QuantityText = styled('span')({
  fontSize: 13,
  fontWeight: 700,
  fontFamily: 'Poppins',
});

export const HelperQuantityText = styled('span')({
  fontWeight: 300,
  color: '#747474',
});

export {
  Container,
  AddContainer,
  AddButton,
  UnitsContainer,
  HeaderModal,
  SelectContainer,
  MenuItemText,
  HelperText,
  QuantityText,
};
